import { BaseModel } from '~/models/baseModel';

export class MulesingModel extends BaseModel {
    public key:string;
    public value:string;
}
